import React from 'react';
import { Alert } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

function ApiValidationErrorDisplay({ errors, clearError }) {
    const dispatch = useDispatch();

    React.useEffect(() => {
        return () => dispatch(clearError());
    }, []);

    return errors.length > 0 ? (
        <Alert
            className="bg-warning-light mt-4"
            onClose={() => dispatch(clearError())}
            dismissible
        >
            <Alert.Heading>
                There was error trying to send your form. Fix these errors and please try again.
            </Alert.Heading>
            <ul>
                {errors.map((item, index) => (
                    <li key={index}>{item}</li>
                ))}
            </ul>
        </Alert>
    ) : (
        ''
    );
}

ApiValidationErrorDisplay.defaultProps = {
    errors: [],
};
ApiValidationErrorDisplay.propTypes = {
    errors: PropTypes.array,
    clearError: PropTypes.func.isRequired,
};
export default ApiValidationErrorDisplay;
